'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTypeByTrigger = function getTypeByTrigger(trigger) {
  return trigger === '@' ? 'mention' : trigger + 'mention';
};

exports.default = getTypeByTrigger;


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-mention-plugin/lib/utils/getTypeByTrigger.js
// module id = 723
// module chunks = 0